import React from "react";
class TelebetPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showExtraDetails: false
        };

        this.handleLogout = this.handleLogout.bind(this);
        this.getQuestionText = this.getQuestionText.bind(this);
        this.toggleExtraDetails = this.toggleExtraDetails.bind(this);


    }

    componentDidMount() {

    }

    handleLogout() {
        this.props.onLogoutRequest();
    }

    toggleExtraDetails(value) {
        const thisComponent = this;
        const showExtraDetails = value === null ? !thisComponent.state.showExtraDetails : value;

        this.setState({
            showExtraDetails: showExtraDetails
        });
    }

    getQuestionText(questionId) {

        const resources = {
            0: "Place Of Birth",
            1: "Mothers Maiden Name",
            2: "First School",
            3: "Favorite Color",
            4: "Favorite Holiday Destination",
            5: "All Time Favorite Jockey",
            6: "Favorite Automobile",
            7: "First Pets Name",
            8: "All Time Favorite Horse",
            9: "City Of Birth",
            10: "Unspecified"
        };

        return resources[questionId];

    }

    render() {
        const currency = GBEUtils.getCurrencySymbol(GBEglobal.currency);
        const showExtraDetails = this.state.showExtraDetails ? " d-block" : "";
        const GBEformatDecimal = GBEUtils.formatDecimal;

        const punter = {
            status: " suspended",
            title: "",
            name: "No Customer Loaded",
            balance: "?",
            exposure: "?",
            commisionRate: "0.00",
            showMoreDetails: () => {}

        };

        if (this.props.telebetPunterDetails && this.props.telebetAccountSummary) {
            punter.status = " active";
            punter.title = Object.keys(gec.Title)[this.props.telebetPunterDetails.title - 1];
            punter.name = this.props.telebetPunterDetails.name;
            punter.balance = this.props.telebetAccountSummary.balance.amount;
            punter.exposure = this.props.telebetAccountSummary.reservations.amount;
            punter.commisionRate = GBEformatDecimal(this.props.telebetAccountSummary.baseCommissionRate, 2);
            punter.username = this.props.telebetPunterDetails.partnerUsername;
            punter.address = this.props.telebetPunterDetails.address;
            punter.phone = this.props.telebetPunterDetails.phone;
            punter.secondaryPhone = this.props.telebetPunterDetails.secondaryPhone;
            punter.email = this.props.telebetPunterDetails.email;
            punter.firstQuestion = this.getQuestionText(this.props.telebetPunterDetails.firstQuestionType - 1);
            punter.secondQuestion = this.getQuestionText(this.props.telebetPunterDetails.secondQuestionType - 1);
            punter.firstQuestionAnswer = this.props.telebetPunterDetails.firstQuestionAnswer;
            punter.secondQuestionAnswer = this.props.telebetPunterDetails.secondQuestionAnswer;
            punter.customerCategory = this.props.telebetPunterDetails.punterCategoryName;
            punter.contactType = Object.keys(gec.ContactType)[this.props.telebetPunterDetails.contactTypeId - 1];
            punter.born = this.props.telebetPunterDetails.birthDate.split("-")[0];
            punter.panNumber = this.props.telebetPunterDetails.panNumber;
            punter.accountNumber = this.props.telebetPunterDetails.punterAccountId;
            punter.accountOpened = new Date(this.props.telebetPunterDetails.activatedAt).toLocaleDateString("en-GB", {
                day: "numeric", month: "short", year: "numeric"
            }).replace(/ /g, "-");
            punter.showMoreDetails = this.toggleExtraDetails.bind(this, null);
        }

        return (
            <>
                <div className="telebetPanel">
                    <span className="telebet-col">
                        <b className={punter.status}>{punter.title} {punter.name}</b>
                    </span>
                    <span className="telebet-col ">
                        <b>Bal:</b> <span className="" dangerouslySetInnerHTML={{ __html: currency }} /> {punter.balance}
                    </span>
                    <span className="telebet-col ">
                        <b>Exp:</b> <span className="" dangerouslySetInnerHTML={{ __html: currency }} /> {punter.exposure}
                    </span>
                    <span className="telebet-col">
                        <b>Comm:</b>  {punter.commisionRate}%
                    </span>
                    <span className="telebet-col">
                        <a className="mr-3" onClick={punter.showMoreDetails}>More</a> <a onClick={this.handleLogout}>Logout</a>
                    </span>
                </div>
                <div className={"telebetPanelExtraDetails" + showExtraDetails}>
                    <a className="hideExtraDetails" onClick={this.toggleExtraDetails.bind(this, false)}>X</a>

                    <div className="row">
                        <div className="col-3">
                            <b>Username</b> {punter.username}
                        </div>
                        <div className="col-3">
                            <b>Addr</b> {punter.address}
                        </div>
                        <div className="col-2">

                        </div>
                        <div className="col-4">
                            <b>{punter.firstQuestion}?</b> {punter.firstQuestionAnswer}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <b>A/C No.</b> {punter.accountNumber}
                        </div>
                        <div className="col-3">
                            <b>Ph 1 </b> {punter.phone}
                        </div>
                        <div className="col-2">
                            <b>Ph 2 </b> {punter.secondaryPhone}
                        </div>
                        <div className="col-4">
                            <b>{punter.secondQuestion}?</b> {punter.secondQuestionAnswer}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <b>A/C Opened</b> {punter.accountOpened}
                        </div>
                        <div className="col-3">
                            <b>Email </b> {punter.email}
                        </div>
                        <div className="col-2">
                            <b>Cust Category</b> {punter.customerCategory}
                        </div>
                        <div className="col-2">
                            <b>Contact Type</b> {punter.contactType}
                        </div>
                        <div className="col-2">
                            <b>Born</b> {punter.born}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <b>PAN</b> {punter.panNumber}
                        </div>
                    </div>
                </div>
            </>

        );
    }
}

export { TelebetPanel };